// import { useEffect } from 'react'
import { useI18n } from '@popety_io/popety-io-lib'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import { estimateSelector } from '../../redux'

import NightAndDay from './components/NightAndDay'
import ScaleDecibels from './components/ScaleDecibels'

const EstimateNoise = () => {
  const { t } = useI18n()
  const estimate = useSelector(estimateSelector)

  return (
    <>
      <Box
        position="sticky"
        top={0}
        pt={2}
        zIndex={10}
        bgcolor="background.paper"
      >
        <Typography
          variant="h2"
          sx={{
            marginBottom: '4px',
            textTransform: 'uppercase',
          }}
          fontSize="1.7rem"
          fontWeight={500}
        >
          {t('common.noise')}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#969696',
            paddingBottom: '10px',
          }}
          fontSize="1rem"
        >
          {t('estimate.Bruit et gêne estimé à cette addresse')}
        </Typography>
      </Box>
      <NightAndDay data={estimate} />
      <ScaleDecibels />
    </>
  )
}

export default EstimateNoise
